<mat-sidenav-container class="example-container" *ngIf="shouldRun">
    <mat-sidenav mode="side" [(opened)]="showSidebar"  >
        <div >
            <div style="border-bottom: solid white;">
                <span class="full-text">
                    <img
                    style="display:block; margin-left: auto; margin-right: auto; height: 4rem;"
                    src="../../../../../assets/WhatNow-logo-version1_rev_2.png"
                />
                </span>
                <span class="short-text">
                    <img
                style="display:block; margin-left: auto; margin-right: auto; height: 2rem;"
                src="../../../../../assets/WhatNow-logo-version1_rev_2.png"
                    />
                </span>
                
            </div>
            
          <div class="heading-text" >
              Appliications
          </div >
            <div *ngIf="showTab.boardMember">
                <span class="full-text">
                    <button mat-button (click)="onTabSelect('boardMember')" [ngClass]="{'change-bg': changecolour.boardMember}">
                        <mat-icon> supervisor_account </mat-icon>
                        Board Members
                    </button>
                </span>
                <span class="short-text">
                    <div (click)="onTabSelect('boardMember')" [ngClass]="{'change-bg': changecolour.boardMember}" class="small-button">
                        <mat-icon> supervisor_account </mat-icon>
                        <span class="small-texts">Member</span>
                    </div>
                </span>
            </div>
            <div *ngIf="showTab.group">
                <span class="full-text">
                    <button mat-button (click)="onTabSelect('group')" [ngClass]="{'change-bg': changecolour.group}">
                        <mat-icon> build </mat-icon>
                        Groups
                    </button>
                </span>
                <span class="short-text">
                    <div (click)="onTabSelect('group')" [ngClass]="{'change-bg': changecolour.group}" class="small-button">
                        <mat-icon> build </mat-icon>
                        <span class="small-texts">Groups</span>
                    </div>
                </span>
            </div>
    
            <div *ngIf="showTab.company">
                <span class="full-text">
                    <button mat-button (click)="onTabSelect('company')" [ngClass]="{'change-bg': changecolour.company}">
                        <mat-icon> business</mat-icon>
                        Company
                    </button>
                </span>
                <span class="short-text">
                    <div (click)="onTabSelect('company')" [ngClass]="{'change-bg': changecolour.company}" class="small-button">
                        <mat-icon> business</mat-icon>
                        <span class="small-texts">Company</span>
                    </div>
                </span>
            </div>
    
            <div *ngIf="showTab.poll">
                <span class="full-text">
                    <button mat-button (click)="onTabSelect('poll')" [ngClass]="{'change-bg': changecolour.poll}">
                        <mat-icon> equalizer </mat-icon>
                        Create Poll
                    </button>
                </span>
                <span class="short-text">
                    <div mat-button (click)="onTabSelect('poll')" [ngClass]="{'change-bg': changecolour.poll}" class="small-button">
                        <mat-icon> equalizer </mat-icon>
                        <span class="small-texts">Create</span>
                    </div>
                </span>
            </div>
    
            <div *ngIf="showTab.execute">
                <span class="full-text">
                    <button mat-button (click)="onTabSelect('execute')" [ngClass]="{'change-bg': changecolour.execute}">
                        <mat-icon> table_chart</mat-icon>
                        Polls
                    </button>
                </span>
                <span class="short-text">
                    <div mat-button (click)="onTabSelect('execute')" [ngClass]="{'change-bg': changecolour.execute}" class="small-button">
                        <mat-icon> table_chart</mat-icon>
                        <span class="small-texts">Polls</span>
                    </div>
                </span>
            </div>
    
            <div *ngIf="showTab.result">
                <span class="full-text">
                    <button mat-button (click)="onTabSelect('result')" [ngClass]="{'change-bg': changecolour.result}">
                        <mat-icon> vertical_split </mat-icon>
                        Poll Results
                    </button>
                </span>
                <span class="short-text">
                    <div (click)="onTabSelect('result')" [ngClass]="{'change-bg': changecolour.result}" class="small-button">
                        <mat-icon> vertical_split </mat-icon>
                        <span class="small-texts">Result</span>
                    </div>
                </span>
            </div>
    
            <div *ngIf="showTab.manage">
                <span class="full-text">
                    <button mat-button (click)="onTabSelect('manage')" [ngClass]="{'change-bg': changecolour.manage}">
                        <mat-icon> person </mat-icon>
                        User Management
                    </button>
                </span>
                <span class="short-text">
                    <div (click)="onTabSelect('manage')" [ngClass]="{'change-bg': changecolour.manage}" class="small-button">
                        <mat-icon> person </mat-icon>
                        <span class="small-texts">Users</span>
                    </div>
                </span>
            </div>
        </div>
        

   

    </mat-sidenav>
    <mat-sidenav-content>
        <div class="header">
            <span (click)="showHideSideBar()">
            <img
                style="height: 30px;"
                src="../../../../../assets/hamburger.png"
            />
            </span>
            <!-- <spam style="float: right;padding-right: 3rem; margin-top: .2rem;">
                <mat-icon (click)="logOut()">settings_power</mat-icon>
            </spam>
            <span style="margin-top: .5rem; float: right; padding-right: 1rem; ">
                {{userName}} 
            </span> -->
            <div class="panel-heading">
                <button mat-button [matMenuTriggerFor]="menu">{{userName}}</button>
                <mat-menu #menu="matMenu">
                    <button mat-menu-item>
                        <mat-icon> person </mat-icon>
                        <span>
                            Profile
                        </span>
                    </button>
                    <button mat-menu-item (click)="logOut()">
                        <mat-icon>power_settings_new</mat-icon>
                        <span>
                            Log out
                        </span>
                    </button>
                    <button mat-menu-item (click)="copyToken()">
                        <mat-icon>file_copy</mat-icon>
                        <span>
                            Copy Token To Clipboard
                        </span>
                    </button>
                </mat-menu>


                <!-- <mat-expansion-panel (opened)="panelOpenState = true"
                                    (closed)="panelOpenState = false">
                    <mat-expansion-panel-header>
                    <mat-panel-description>
                        {{userName}} 
                    </mat-panel-description>
                    </mat-expansion-panel-header>
                    <div  class="panel-con">
                        <mat-icon> person </mat-icon>
                        <span>
                            Profile
                        </span>
                    </div><br>
                    <div class="panel-con"(click)="logOut()">
                        <mat-icon>power_settings_new</mat-icon>
                        <span>
                            Log out
                        </span>
                    </div>
           
                </mat-expansion-panel> -->
                <!-- <mat-label>{{userName}}</mat-label>
                <mat-select >
                    <mat-option>Profile</mat-option>
                    <mat-option (click)="logOut()">Log out</mat-option>
                </mat-select> -->
            </div>
            
            <!-- <div style="float: right; padding-right: 20px; margin-top: 0.5vw; display:block">
                <div style="padding-bottom: 10px;" class="user-name">
                    {{userName}}
                </div>
                <div class="power-icon">
                    <mat-icon (click)="logOut()">settings_power</mat-icon>
                </div>
                
                
                <mat-icon (click)="logOut()">settings_power</mat-icon>
                <button type="button" (click)="logOut()" >LogOut</button>
            </div> -->
           
            <!-- <div style="float: right; padding-right: 20px;">
                <img 
                 style= "height: 30px;"
                 src="../../../../../assets/WhatNow-logo-version1_rev_2.jpg"
                 />
            </div> -->
        </div>
        <div>
            <router-outlet></router-outlet>
        </div>
        
    </mat-sidenav-content>
</mat-sidenav-container> 
<!-- <header-test></header-test> -->